<template>
  <transition name="fade" mode="out-in">
    <div class="screen-wrap">
      <v-app class="hmc-app">
        <v-main class="main-body">
          <v-container class="app-body">
            <div class="pe-2 ps-3 app-title text-h5">
              {{ $t("string.dailyQuests") }}
              <v-spacer></v-spacer>
              <CloseBtn size="40" :callback="exit" />
            </div>
            <Loader v-if="api.isLoading" :isLoading="api.isLoading" />
            <div v-else class="px-5">

              <div class="subtitle text-center text-h5">
                {{ $t("string.weekYear", { week: $moment().isoWeek(), year: $moment().year() }) }}
              </div>
              <div class="subtitle text-center mb-2">
                {{ quests[0].PlayerQuest.timestampClaimed ? $t("string.questMsg2") : $t("string.questMsg1") }}

              </div>
              <div class="text-center mb-4">
                <CountDown :endTime="$moment().isoWeek($moment().isoWeek() + 1).startOf('isoWeek')"
                  :message="$t('string.resetIn')" />
              </div>

              <div v-for="quest in quests" :key="quest.key">
                <v-card flat class="my-2 list-card-z">
                  <div class="d-flex flex-no-wrap align-center">
                    <div class="text-center mx-4 mt-2" v-for="(rwd, j) in quest.Reward" :key="j + 'qi'">
                      <div>
                        <v-img contain max-height="50" max-width="50" :src="rwd.Item.images.icon.url">
                        </v-img>
                        <div class="me-1">+{{ rwd.quantity }}</div>
                      </div>
                    </div>

                    <div style="width: 100%" class="pa-2">
                      <div class="text-h6">
                        {{ quest.name }}
                      </div>
                      <div class="d-flex flex-no-wrap align-center">
                        <div style="width: 100%" class="pe-3">
                          <v-progress-linear
                            :value="Math.min(loggedData.data.day, getDayFromKey(quest.key)) / getDayFromKey(quest.key) * 100"
                            color="green" height="20" rounded>
                            {{ Math.min(loggedData.data.day, getDayFromKey(quest.key)) }} /
                            {{ getDayFromKey(quest.key) }}</v-progress-linear>
                        </div>
                        <v-icon large v-if="quest.PlayerQuest.timestampClaimed" color="green">
                          mdi-check-circle
                        </v-icon>
                        <v-btn v-else-if="getDayFromKey(quest.key) <= loggedData.data.day" color="yellow"
                          class="text-h6 constant-tilt-shake" @click="claimQuest(quest)"
                          :loading="api.isLoading && selectedItem == quest">
                          {{ $t("action.claim") }}
                        </v-btn>
                        <v-btn v-else color="grey" dark depressed>
                          <v-icon> mdi-lock </v-icon>
                        </v-btn>
                      </div>
                    </div>
                  </div>
                </v-card>
                <v-divider class="my-4" v-if="quest.key == 'QT_DAILY_COLLECT_DAY_7_LOGIN'"></v-divider>
              </div>
            </div>
          </v-container>
        </v-main>
        <ApiErrorDialog v-if="api.isError" :api="api" />
        <RewardDialog v-if="rwdDialog" :callbackClose="() => (rwdDialog = false)" :showDialog="true"
          :rewards="rewards" />
      </v-app>
    </div>
  </transition>
</template>

<script>
import { mapState } from "vuex";
export default {
  components: {
    CloseBtn: () =>
      import(
        /* webpackChunkName: "component-btn-close" */ "@/components/btns/CloseBtn"
      ),
    ApiErrorDialog: () =>
      import(
        /* webpackChunkName: "component-api-error-dialog" */ "@/components/ApiErrorDialog.vue"
      ),
    RewardDialog: () =>
      import(
        /* webpackChunkName: "component-reward" */ "@/components/ABC/RewardDialog"
      ),
    CountDown: () =>
      import(
        /* webpackChunkName: "component-countdown" */ "@/components/CountDown.vue"
      ),
  },
  computed: {
    ...mapState({
      settings: (state) => state.settings.data,
      auth: (state) => state.auth.data,
    }),
  },
  props: [
    //
  ],
  data: () => ({
    api: {
      isLoading: false,
      isError: false,
      error: null,
      url: null,
    },
    quests: [],
    loggedData: null,
    selectedItem: null,
    rwdDialog: false,
    rewards: [],
    xp: {
      currentLevel: 0,
      currentXp: 0,
      nextLevel: 0,
      nextXpThreshold: 1,
    },
  }),
  async created() {
    await this.loadXP()
    if (this.xp.currentLevel >= 3)
      await this.getQuest()
    else
      this.$router.push({
        name: "PageWorldNews",
      });
  },
  mounted() {
    //
  },
  methods: {
    exit() {
      this.$router.push({
        name: "PageWorldNews",
      });
    },
    claimQuest(item) {
      this.selectedItem = item;
      this.api.url =
        this.$api.servers.game +
        "/api/v1/" +
        this.$_getLocale() +
        "/game/quest/open";

      this.api.callbackReset = () => {
        this.api.isLoading = true;
        this.api.isError = false;
        this.api.error = null;
      };
      this.api.callbackError = (e) => {
        this.api.isLoading = false;
        this.api.isError = true;
        this.api.error = e;
      };
      this.api.callbackSuccess = (resp) => {
        this.api.isLoading = false;
        this.rewards = resp.Reward;
        this.rwdDialog = true;
        this.getQuest();
      };
      this.api.params = {
        key: item.key,
      };
      this.$api.fetch(this.api);
    },
    async getQuest() {
      this.quests = [];
      this.api.url =
        this.$api.servers.game +
        "/api/v1/" +
        this.$_getLocale() +
        "/game/quest/visit";

      this.api.callbackReset = () => {
        this.api.isLoading = true;
        this.api.isError = false;
        this.api.error = null;
      };
      this.api.callbackError = (e) => {
        this.api.isLoading = false;
        this.api.isError = true;
        this.api.error = e;
      };
      this.api.callbackSuccess = (resp) => {
        this.api.isLoading = false;
        this.quests = this.reorderQuests(resp.Quest);
        this.loggedData = resp.Save
        console.log(resp);

      };
      this.api.params = {
        model: "DailyLogin",
        modelKey: "DLQV01",
      };

      await this.$api.fetch(this.api);
    },
    async loadXP() {
      this.api.url =
        this.$api.servers.game +
        "/api/v1/" +
        this.$_getLocale() +
        "/game/xp/load";
      this.api.callbackReset = () => {
        this.api.isLoading = true;
        this.api.isError = false;
        this.api.error = null;
      };
      this.api.callbackError = (e) => {
        this.api.isLoading = false;
        this.api.isError = true;
        this.api.error = e;
        console.error(e);
      };
      this.api.callbackSuccess = (resp) => {
        this.api.isLoading = false;
        this.xp = resp;
      };
      await this.$api.fetch(this.api);
    },
    reorderQuests(quests) {
      // Extract the Day 7 quest
      const day7Quest = quests.find(q => q.key === "QT_DAILY_COLLECT_DAY_7_LOGIN");

      // Filter out Day 7 from the rest
      const otherDays = quests.filter(q => q.key !== "QT_DAILY_COLLECT_DAY_7_LOGIN");

      // Sort the remaining quests:
      // 1. By claimed status (null first)
      // 2. Then by day number extracted from the key
      const sortedOthers = otherDays.sort((a, b) => {
        const aClaimed = a.PlayerQuest?.timestampClaimed != null;
        const bClaimed = b.PlayerQuest?.timestampClaimed != null;

        if (aClaimed !== bClaimed) {
          return aClaimed ? 1 : -1; // Unclaimed first
        }

        const aDay = parseInt(a.key.match(/DAY_(\d+)_LOGIN/)[1]);
        const bDay = parseInt(b.key.match(/DAY_(\d+)_LOGIN/)[1]);

        return aDay - bDay;
      });

      // Return new array with Day 7 first
      return [day7Quest, ...sortedOthers];
    },

    getDayFromKey(key) {
      const match = key.match(/DAY_(\d+)_LOGIN/);
      return match ? parseInt(match[1], 10) : null;
    }
  },
};
</script>

<style scoped>
.subtitle {
  color: #4a3c31d7;
}

.app-title {
  z-index: 99;
  position: fixed;
  top: 0;
  max-width: 480px !important;
  width: 100%;
  display: flex;
  align-items: center;
  height: 60px;
  box-shadow: 0px 5px 2px rgba(128, 128, 128, 0.5) !important;
  border: #caad87 5px solid;
  margin: auto;
  color: #fff;
  background-color: #f7efe3;
  text-shadow: #cbb18f 3px 0px 0px, #cbb18f 2.83487px 0.981584px 0px,
    #cbb18f 2.35766px 1.85511px 0px, #cbb18f 1.62091px 2.52441px 0px,
    #cbb18f 0.705713px 2.91581px 0px, #cbb18f -0.287171px 2.98622px 0px,
    #cbb18f -1.24844px 2.72789px 0px, #cbb18f -2.07227px 2.16926px 0px,
    #cbb18f -2.66798px 1.37182px 0px, #cbb18f -2.96998px 0.42336px 0px,
    #cbb18f -2.94502px -0.571704px 0px, #cbb18f -2.59586px -1.50383px 0px,
    #cbb18f -1.96093px -2.27041px 0px, #cbb18f -1.11013px -2.78704px 0px,
    #cbb18f -0.137119px -2.99686px 0px, #cbb18f 0.850987px -2.87677px 0px,
    #cbb18f 1.74541px -2.43999px 0px, #cbb18f 2.44769px -1.73459px 0px,
    #cbb18f 2.88051px -0.838247px 0px;
}

.text-stroke-sm {
  color: #fff;
  text-shadow: #8b5629 3px 0px 0px, #8b5629 2.83487px 0.981584px 0px,
    #8b5629 2.35766px 1.85511px 0px, #8b5629 1.62091px 2.52441px 0px,
    #8b5629 0.705713px 2.91581px 0px, #8b5629 -0.287171px 2.98622px 0px,
    #8b5629 -1.24844px 2.72789px 0px, #8b5629 -2.07227px 2.16926px 0px,
    #8b5629 -2.66798px 1.37182px 0px, #8b5629 -2.96998px 0.42336px 0px,
    #8b5629 -2.94502px -0.571704px 0px, #8b5629 -2.59586px -1.50383px 0px,
    #8b5629 -1.96093px -2.27041px 0px, #8b5629 -1.11013px -2.78704px 0px,
    #8b5629 -0.137119px -2.99686px 0px, #8b5629 0.850987px -2.87677px 0px,
    #8b5629 1.74541px -2.43999px 0px, #8b5629 2.44769px -1.73459px 0px,
    #8b5629 2.88051px -0.838247px 0px;
}

.main-body {
  /*background-color: #c7e5e9;*/
  background-color: rgba(214, 132, 49, 0.3);
}

.app-body {
  max-width: 480px;
  min-height: 100%;
  padding: 80px 0 40px 0;
  /* background-color: #f5dfc5; */
}

.list-card-z {
  padding: 5px !important;
  color: #785c3a !important;
  border-radius: 5px !important;
  border: #ccaf8b 4px solid !important;
  background-color: #fff9f1 !important;
  overflow-x: hidden !important;
}

.constant-tilt-shake {
  animation: tilt-shaking 2s infinite;
}

.constant-tilt-shake:hover {
  animation: none;
}

@keyframes tilt-shaking {
  0% {
    transform: translate(0, 0) rotate(0deg);
  }

  3% {
    transform: translate(2px, -2px) rotate(5deg);
  }

  6% {
    transform: translate(0, 0) rotate(0eg);
  }

  9% {
    transform: translate(-2px, -2px) rotate(-5deg);
  }

  12% {
    transform: translate(0, 0) rotate(0deg);
  }

  15% {
    transform: translate(2px, -2px) rotate(5deg);
  }

  18% {
    transform: translate(0, 0) rotate(0eg);
  }

  21% {
    transform: translate(-2px, -2px) rotate(-5deg);
  }

  24% {
    transform: translate(0, 0) rotate(0deg);
  }

  100% {
    transform: translate(0, 0) rotate(0deg);
  }
}
</style>